import React from "react";

import Chef1 from "../images/chefs-1.jpg";
import Chef2 from "../images/chefs-2.jpg";
import Chef3 from "../images/chefs-3.jpg";

const Chefs = () => {
    const chefArray = [
        {
            image: Chef1,
            name: "Walter White",
        },
        {
            image: Chef2,
            name: "Sarah Jhonson",
        },
        {
            image: Chef3,
            name: "William Anderson",
        },
    ];

    return (
        <>
            <section id="chefs" className="chefs">
                <div className="container">
                    <div className="section-title">
                        <h2>
                            Our Proffesional <span>Chefs</span>
                        </h2>
                    </div>

                    <div className="row">
                        {chefArray?.map((data) => {
                            return (
                                <div className="col-lg-4 col-md-6">
                                    <div className="member">
                                        <div className="pic">
                                            <img
                                                draggable={false}
                                                src={data.image}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="member-info">
                                            <h4>{data.name}</h4>
                                            <div className="social">
                                                <a target="_blank" href="https://twitter.com">
                                                    <i
                                                        className="fab fa-twitter ml-2"
                                                        style={{ color: "#00ACEE" }}
                                                    ></i>
                                                </a>
                                                <a target="_blank" href="https://facebook.com">
                                                    <i className="fab fa-facebook ml-2 text-primary"></i>
                                                </a>
                                                <a target="_blank" href="https://instagram.com">
                                                    <i className="fab fa-instagram ml-2 text-danger"></i>
                                                </a>
                                                <a target="_blank" href="https://linkedin.com">
                                                    <i
                                                        className="fab fa-linkedin ml-2"
                                                        style={{ color: "#0e76a8" }}
                                                    ></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Chefs;
